import * as React from 'react';
import './badge.scss';

export type BadgeType = 'success' | 'error' | 'primary' | 'info' | 'secondary' | 'waiting';

interface Props {
    className?: string;
    type: BadgeType;
    text: string | number;
    icon?: string;
}

export const Badge: React.FC<Props> = (props) => {
    return (
        <div className={`pmx-badge${props.className && props.className !== '' ? props.className : ''}`}>
            <div className={props.type}>
                {props.icon && <img src={props.icon} />}
                <span>{props.text}</span>
            </div>
        </div>
    );
};
